import React from 'react';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';

const WithSidebar = ({ content, sidebar }) => {
    return (
        <Stack
            sx={{
                position: 'relative',
                display: 'flex',
                flexDirection: { xs: 'column', md: 'row' },
                minHeight: '100vh',
                width: '100%',
                maxWidth: '1150px',
                gap: { xs: 4, md: 3 },
            }}
        >
            <Box sx={{ width: '100%' }}>{content}</Box>
            <Stack
                sx={{
                    position: 'sticky',
                    top: 24,
                    height: 'fit-content',
                    alignItems: 'center',
                    minWidth: { md: 350 },
                    maxWidth: { md: 350 },
                    gap: { xs: 1, md: 0 },
                }}
            >
                {sidebar}
            </Stack>
        </Stack>
    );
};

export { WithSidebar };
